export const API_URL = {
  VALIDATION_PREFETCH: '/risk/verify/identity/validation/prefetch',
  VALIDATION_TOKEN: '/risk/verify/identity/validation/token',
  VALIDATION_CHECK: '/risk/verify/identity/validation/check',
  VALIDATION_GUIDE: '/risk/verify/identity/guide',
  GEETEST_REGISTER: '/risk/verify/identity/geetest/register',
  VALIDATION_RESOURCES: '/risk/verify/identity/validation/resources',
  VALIDATION_SEND: '/risk/verify/identity/validation/send',
  VALIDATION_SINGLE_CHECK: '/risk/verify/identity/validation/single/check',
};
